import React from "react";
import {
  EquipmentContainer,
  AutovehicleSpecsInputContainer,
} from "../../styled/potree/PotreeControl.styles";

/**
 * 농기구 선택 + 차량 스펙 5개 input (자동/수동 공통)
 * store 미사용, 모든 값·핸들러는 props로 전달
 */
function VehicleSpecsForm({
  selectedAutovehicleSpecs,
  AutovehicleSpecs,
  currentSpecs,
  onEquipmentChange,
  onSpecInputChange,
}) {
  return (
    <>
      <EquipmentContainer>
        <h2>농기구 선택</h2>
        <select
          name="equipment"
          id="equipment-select"
          value={selectedAutovehicleSpecs}
          onChange={onEquipmentChange}
        >
          {Object.values(AutovehicleSpecs).map((spec, index) => (
            <option key={index} value={index + 1}>
              {spec.name}
            </option>
          ))}
        </select>
      </EquipmentContainer>

      <AutovehicleSpecsInputContainer>
        <div>
          <label>축간거리 (m)</label>
          <input
            type="number"
            placeholder="축간거리 (m)"
            value={currentSpecs.wheelBase ?? ""}
            onChange={(e) =>
              onSpecInputChange("wheelBase", e.target.value)
            }
            disabled={selectedAutovehicleSpecs !== "3"}
          />
        </div>
        <div>
          <label>조향각 (°)</label>
          <input
            type="number"
            placeholder="조향각 (°)"
            value={currentSpecs.steeringAngle ?? ""}
            onChange={(e) =>
              onSpecInputChange("steeringAngle", e.target.value)
            }
            disabled={selectedAutovehicleSpecs !== "3"}
          />
        </div>
        <div>
          <label>차체길이 (m)</label>
          <input
            type="number"
            placeholder="차체길이 (m)"
            value={currentSpecs.vehicleLength ?? ""}
            onChange={(e) =>
              onSpecInputChange("vehicleLength", e.target.value)
            }
            disabled={selectedAutovehicleSpecs !== "3"}
          />
        </div>
        <div>
          <label>폭 (m)</label>
          <input
            type="number"
            placeholder="폭 (m)"
            value={currentSpecs.width ?? ""}
            onChange={(e) =>
              onSpecInputChange("width", e.target.value)
            }
            disabled={selectedAutovehicleSpecs !== "3"}
          />
        </div>
        <div>
          <label>회전반경 (m)</label>
          <input
            type="number"
            placeholder="회전반경 (m)"
            value={currentSpecs.turningRadius ?? ""}
            onChange={(e) =>
              onSpecInputChange("turningRadius", e.target.value)
            }
            disabled={selectedAutovehicleSpecs !== "3"}
          />
        </div>
      </AutovehicleSpecsInputContainer>
    </>
  );
}

export default VehicleSpecsForm;
